import { FC } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import dynamic from 'next/dynamic'

const SortableWebsites = dynamic(
  () => import('../website/sort').then((mod) => mod.SortableWebsites),
  {
    loading: () => <p>Loading...</p>,
    ssr: false,
  }
)

export const SortableWebsiteListMock: FC<{
  data?: any[]
  visible?: boolean
  translation?: string
  onSubmitSort?(x?: any): any
}> = ({ data, visible, translation, onSubmitSort }) => {
  const { t } = useTranslation(translation || 'dashboard')

  return (
    <div className='h-full min-h-[40vw]'>
      <h2 className='py-3 text-base'>
        {t(visible ? 'drag-title' : 'sub-header')}
      </h2>
      <SortableWebsites
        data={data?.map((item: any) => ({
          content: item ? item.domain : '',
          id: item ? item.domain : '',
        }))}
        onSubmitSort={onSubmitSort}
      />
    </div>
  )
}
